import { createFileRoute } from "@tanstack/react-router";
import { trpc } from "~/utils/trpc.client";
import { useSearchParamState } from "~/clientUtils";
import { Button } from "~/components/Button";

export const Route = createFileRoute("/_authed/admin/rum-page-views")({
  component: RumPageViews,
});

function RumPageViews() {
  const [search, setSearch] = useSearchParamState("search", "");
  const [personId, setPersonId] = useSearchParamState("personId", "");
  const [teamId, setTeamId] = useSearchParamState("teamId", "");
  const [sessionId, setSessionId] = useSearchParamState("sessionId", "");
  const [startDate, setStartDate] = useSearchParamState("startDate", "");
  const [endDate, setEndDate] = useSearchParamState("endDate", "");

  const rumData = trpc.rum.getRumPageViews.useQuery({
    search,
    personId: personId || undefined,
    teamId: teamId || undefined,
    sessionId: sessionId || undefined,
    startDate: startDate ? new Date(startDate) : undefined,
    endDate: endDate ? new Date(endDate) : undefined,
    limit: 100,
  });

  return (
    <div className="flex flex-col gap-4 m-4">
      <form
        className="grid grid-cols-[repeat(6,1fr)_max-content] gap-2 items-end"
        onSubmit={(e) => {
          e.preventDefault();
        }}
      >
        <div className="flex flex-col gap-1">
          <label className="text-xs opacity-70">Route</label>
          <input
            type="text"
            className="input input-bordered input-sm"
            value={search}
            onChange={(e) => {
              setSearch(e.target.value);
            }}
            placeholder="Search routes..."
          />
        </div>
        <div className="flex flex-col gap-1">
          <label className="text-xs opacity-70">Person ID</label>
          <input
            type="text"
            className="input input-bordered input-sm"
            value={personId}
            onChange={(e) => {
              setPersonId(e.target.value);
            }}
            placeholder="P..."
          />
        </div>
        <div className="flex flex-col gap-1">
          <label className="text-xs opacity-70">Team ID</label>
          <input
            type="text"
            className="input input-bordered input-sm"
            value={teamId}
            onChange={(e) => {
              setTeamId(e.target.value);
            }}
            placeholder="T..."
          />
        </div>
        <div className="flex flex-col gap-1">
          <label className="text-xs opacity-70">Session ID</label>
          <input
            type="text"
            className="input input-bordered input-sm"
            value={sessionId}
            onChange={(e) => {
              setSessionId(e.target.value);
            }}
            placeholder="RS..."
          />
        </div>
        <div className="flex flex-col gap-1">
          <label className="text-xs opacity-70">Start Date</label>
          <input
            type="datetime-local"
            className="input input-bordered input-sm"
            value={startDate}
            onChange={(e) => {
              setStartDate(e.target.value);
            }}
          />
        </div>
        <div className="flex flex-col gap-1">
          <label className="text-xs opacity-70">End Date</label>
          <input
            type="datetime-local"
            className="input input-bordered input-sm"
            value={endDate}
            onChange={(e) => {
              setEndDate(e.target.value);
            }}
          />
        </div>
        <Button
          type="submit"
          loading={rumData.isFetching}
          className="btn-primary btn-sm btn h-[2.5rem]"
        >
          Search
        </Button>
      </form>

      {rumData.data ? (
        <div className="overflow-x-auto">
          <table className="table table-zebra w-full">
            <thead>
              <tr>
                <th>Time</th>
                <th>Person</th>
                <th>Team</th>
                <th>Session</th>
                <th>Route</th>
                <th>Duration</th>
                <th>Active</th>
                <th>Clicks</th>
                <th>Keys</th>
                <th>Sugs</th>
                <th>Opp Sugs</th>
                <th>Gen</th>
                <th>Dict</th>
              </tr>
            </thead>
            <tbody>
              {rumData.data.map((view) => (
                <tr key={view.id} className="hover">
                  <td className="whitespace-nowrap">
                    {view.createdAt.toLocaleString()}
                  </td>
                  <td>
                    <details className="text-sm marker:content-[''] marker:hidden cursor-pointer">
                      <summary>{view.personName}</summary>
                      <div className="text-xs opacity-70">{view.personId}</div>
                      <div className="text-xs opacity-70">
                        {view.personEmail}
                      </div>
                    </details>
                  </td>
                  <td>{view.teamName}</td>
                  <td className="font-mono text-xs">{view.sessionId}</td>
                  <td className="font-mono text-sm">
                    <a href={view.route} target="_blank" rel="noreferrer">
                      {view.route}
                    </a>
                  </td>
                  <td>{Math.round(view.durationMs / 1000)}s</td>
                  <td>{Math.round(view.activeDurationMs / 1000)}s</td>
                  <td>{view.clicks}</td>
                  <td>{view.keypresses}</td>
                  <td>
                    {view.suggestionsAccepted}/{view.suggestions}
                  </td>
                  <td>
                    {view.opportunisticSuggestionsAccepted}/
                    {view.opportunisticSuggestions}
                  </td>
                  <td>
                    {view.generationsAccepted}/{view.generations}
                  </td>
                  <td>
                    {view.dictationsAccepted}/{view.dictations}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          {rumData.data.length === 0 && (
            <div className="flex h-16 items-center justify-center text-center text-sm italic opacity-70">
              No page views found
            </div>
          )}
        </div>
      ) : (
        <div className="w-full flex justify-center">
          <div className="loading"></div>
        </div>
      )}
    </div>
  );
}
